module.exports = __webpack_public_path__ + "img/ARTHUR_1.83cf0dc2.png";